export default (preloadFunction: Function, timeout: number) => {
    let hoverTimer: NodeJS.Timeout
    const startHoverTimer = () => {
        hoverTimer = setTimeout(() => {
            preloadFunction()
        }, timeout)
    }
    const clearHoverTimer = () => {
        clearTimeout(hoverTimer)
    }

    return { startHoverTimer, clearHoverTimer }
}
